// Store / branch selector tour - global (header button + slide-in drawer).
// Picking a store reloads the page, so the tour explains it rather than asking for it.
//
// Core V8.018.010 replaced the branch selector with the fulfilment selector
// (#fulfilment-selector-*: Delivery | Collect toggle, branch list, Save). The
// selectors below take the new ids first and keep the old ones as a fallback.
import { exists, visible, sleep } from './util.js';

var BTN = '#fulfilment-selector-btn, #branch-selector-btn';

function drawer() { return document.getElementById('fulfilment-selector-drawer') || document.getElementById('branch-selector-drawer'); }
function drawerOpen() {
  var d = drawer();
  return !!d && (d.classList.contains('open') || d.getAttribute('aria-hidden') === 'false');
}
async function openDrawer() {
  if (drawerOpen()) return;
  try {
    if (window.SFUI && window.SFUI.branchSelector && typeof window.SFUI.branchSelector.openDrawer === 'function') window.SFUI.branchSelector.openDrawer();
    else { var b = document.querySelector(BTN); if (b) b.click(); }
  } catch (e) { /* ignore */ }
  await sleep(380); // slide-in transition
}

export default {
  id: 'branch-selector',
  version: 2,
  title: 'Choose your store',
  icon: 'store',
  duration: '25 sec',
  scope: 'global',
  autoInvite: false,
  available: function () { return exists(BTN) || exists('#fulfilment-selector-drawer, #branch-selector-drawer'); },
  contextual: drawerOpen,
  invite: {
    kicker: 'Store selector',
    title: 'Picking a store? Here’s what it changes',
    body: 'A quick look at how your store sets stock, prices and collection, and how to find the nearest one.',
  },
  steps: [
    {
      when: function () { return !drawerOpen(); },
      target: BTN,
      icon: 'store',
      title: 'Your store matters',
      body: 'Stock levels, collection and delivery are all based on the store you choose. Open the store list here.',
      interactive: {
        on: 'click',
        check: drawerOpen,
        hint: 'Tap to open the store list',
        done: 'Opening…',
        delay: 500,
      },
    },
    {
      before: openDrawer,
      target: function () { return drawerOpen() ? drawer() : null; },
      icon: 'store',
      title: 'Every Goldwagen store',
      body: 'All our stores in one list, with address, trading hours and contact details for each.',
      placement: 'left',
      padding: 0,
      radius: 0,
      hideBack: true,
    },
    {
      target: '#fulfilment-toggle-delivery',
      icon: 'store',
      title: 'Delivery or collection',
      body: 'Choose whether we deliver to you or you collect in-store. Collection lists only the stores you can collect from.',
      optional: true,
      waitFor: 600,
    },
    {
      when: function () { return !!visible('#fulfilment-selector-geo, #branch-selector-geo'); },
      target: function () { return visible('#fulfilment-selector-geo') || visible('#branch-selector-geo'); },
      icon: 'locate',
      title: 'Find the nearest store',
      body: 'Allow location access and we will sort the list by distance from you.',
      optional: true,
      waitFor: 600,
    },
    {
      when: function () { return !!visible('#fulfilment-selector-search, #branch-selector-search'); },
      target: function () { return visible('#fulfilment-selector-search') || visible('#branch-selector-search'); },
      icon: 'search',
      title: 'Search by town or suburb',
      body: 'Start typing and the list filters as you go.',
      interactive: {
        on: 'input',
        hint: 'Try it: type your suburb',
        done: 'Filtered. Clear the box to see every store again.',
        autoAdvance: false,
      },
    },
    {
      target: function () { return visible('#fulfilment-selector-ul .fulfilment-selector-item') || visible('#branch-selector-ul .branch-selector-item'); },
      icon: 'pin',
      title: 'Tap a store to select it',
      body: 'Pick a store, then Save. The page refreshes so stock and collection options update for that store. You can switch whenever you like.',
      padding: 4,
      optional: true,
    },
    {
      target: '#fulfilment-selector-save, #branch-selector-clear',
      icon: 'check',
      title: 'Save your choice',
      body: 'Save applies the store and delivery or collection choice.',
      optional: true,
      waitFor: 500,
    },
    {
      target: '#fulfilment-selector-close, #branch-selector-close',
      icon: 'check',
      title: 'That’s it',
      body: 'Close the drawer whenever you are done. Your choice is remembered on this device.',
      nextLabel: 'Got it',
      optional: true,
    },
  ],
};
